import { useCallback } from 'react';
import { useService } from '@jira/platform__use-service/src/useService.tsx';
import type { CmdbObject } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/cmdb-object.tsx';
import { fetchInsightId } from './fetch-insight-id/index.tsx';
import { fetchObjectDetails } from './fetch-object-details/index.tsx';
import { fetchReadOnlySchemaId } from './fetch-read-only-schema-id/index.tsx';

export const useFetchObjectDetails = (
	workspaceId?: string,
	// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
	serviceId: string,
) => {
	const request = useCallback(() => {
		if (workspaceId == null) {
			return Promise.resolve(undefined);
		}

		return fetchReadOnlySchemaId(workspaceId)
			.then((readOnlySchemaId) => fetchInsightId(workspaceId, readOnlySchemaId, serviceId))
			.then((workspaceAndObjectId: string) => fetchObjectDetails(workspaceAndObjectId));
	}, [serviceId, workspaceId]);

	return useService<CmdbObject>(request);
};
